/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Work_0_DescInputs */

const en_svc_ai_agent_development_work_0_desc = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A guided AI tutor that plans lessons, adapts to your pace, and routes every response through a cost-aware inference gate.`)
};

const ar_svc_ai_agent_development_work_0_desc = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرشد ذكاء اصطناعي يخطط للدروس ويتكيف مع إيقاعك ويمرر كل استجابة عبر بوابة استدلال تراعي التكلفة.`)
};

const bn_svc_ai_agent_development_work_0_desc = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`একটি গাইডেড AI টিউটর যা পাঠ পরিকল্পনা করে, আপনার গতিতে খাপ খায় এবং প্রতিটি রেসপন্স কস্ট-সচেতন ইনফারেন্স গেট দিয়ে রাউট করে।`)
};

const de_svc_ai_agent_development_work_0_desc = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein geführter KI-Tutor, der Unterrichtsstunden plant, sich an Ihr Tempo anpasst und jede Antwort durch ein kostenbewusstes Inference-Gate leitet.`)
};

const es_svc_ai_agent_development_work_0_desc = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un tutor de IA guiado que planifica lecciones, se adapta a su ritmo y dirige cada respuesta a través de un gateway de inferencia consciente de los costos.`)
};

const fr_svc_ai_agent_development_work_0_desc = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un tuteur d'IA guidé qui planifie les leçons, s'adapte à votre rythme et achemine chaque réponse via un gateway d'inférence sensible aux coûts.`)
};

const pt_svc_ai_agent_development_work_0_desc = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um tutor guiado de IA que planeja aulas, se adapta ao seu ritmo e encaminha cada resposta por meio de um gateway de inferência consciente dos custos.`)
};

const zh_svc_ai_agent_development_work_0_desc = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会规划课程、适应节奏的口语家教，经成本感知的推理网关做流式传输。`)
};

const tr_svc_ai_agent_development_work_0_desc = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dersleri planlayan, hızınıza uyum sağlayan ve her yanıtı maliyet bilinçli bir inference gateway'inden geçiren rehberli bir YZ öğretmeni.`)
};

const ru_svc_ai_agent_development_work_0_desc = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гайдед ИИ-тьютор, планирующий уроки, подстраивающийся под ваш темп и гоняющий каждый ответ через inference-шлюз с контролем цены.`)
};

const pl_svc_ai_agent_development_work_0_desc = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opiekun AI, który planuje lekcje, dostosowuje się do twojego tempa i kieruje każdą odpowiedź przez gateway inferencji świadomy kosztów.`)
};

/**
* | output |
* | --- |
* | "A guided AI tutor that plans lessons, adapts to your pace, and routes every response through a cost-aware inference gate." |
*
* @param {Svc_Ai_Agent_Development_Work_0_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_work_0_desc = /** @type {((inputs?: Svc_Ai_Agent_Development_Work_0_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Work_0_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_work_0_desc(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_work_0_desc(inputs)
	if (locale === "de") return de_svc_ai_agent_development_work_0_desc(inputs)
	if (locale === "es") return es_svc_ai_agent_development_work_0_desc(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_work_0_desc(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_work_0_desc(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_work_0_desc(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_work_0_desc(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_work_0_desc(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_work_0_desc(inputs)
	return en_svc_ai_agent_development_work_0_desc(inputs)
});
export { svc_ai_agent_development_work_0_desc as "svc_ai-agent-development_work_0_desc" }